import React, { useEffect, useRef } from "react"
import {Modal,ScrollView,Select,Text,Button,Center,VStack,FormControl, HStack,Box,Checkbox, Input, IconButton,CheckIcon,DeleteIcon,} from 'native-base'
import useDialogA11y from "../hooks/useDialogA11y";
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import FormControlLabel from '@mui/material/FormControlLabel';
import MuiCheckbox from '@mui/material/Checkbox';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import Notiflix from "notiflix";
const filter = createFilterOptions();
const AddTableModal =({opened,closeHandler,categories,onAdd})=>{
    const dialogRef = useRef(null);

    const [category,setCategory] = React.useState(null)
    const[tableNumbers,setTableNumbers] = React.useState(null)
    const [tableType, setTableType] = React.useState('standard')
    const [seatCount, setSeatCount] = React.useState(4)
    const [wheelchairAccessible, setWheelchairAccessible] = React.useState(true)
    const [zone, setZone] = React.useState('inside')
    const [floor, setFloor] = React.useState('ground')
    const [elevated, setElevated] = React.useState(false)

    useEffect(()=>{
        if(!opened){
            setCategory(null)
            setTableNumbers(null)
            setTableType('standard')
            setSeatCount(4)
            setWheelchairAccessible(true)
            setZone('inside')
            setFloor('ground')
            setElevated(false)
        }
    },[opened])

    // Auto-set wheelchair based on table type
    useEffect(()=>{
        if(tableType === 'booth' || tableType === 'bar-stool' || tableType === 'high-top' || tableType === 'high-table'){
            setWheelchairAccessible(false)
        } else {
            setWheelchairAccessible(true)
        }
    },[tableType])

    const onAddClicked =()=>{



        
        //if only one
        const extraFields = { tableType, seatCount: parseInt(seatCount) || 4, wheelchairAccessible, zone, floor, elevated }

        if(!isNaN(tableNumbers) && category && category.title.length>1){
            onAdd([parseInt(tableNumbers)],category.title, extraFields)
            return
        }

        
        let n =[]
        let hasNumbers=false;
        if(tableNumbers!=null&& tableNumbers !== undefined && tableNumbers.length!== 0 ){
           
           
            let ncomma = tableNumbers.split(',')
            let nperiod = tableNumbers.split('-')
            if(tableNumbers.indexOf(',')!==-1 && tableNumbers.indexOf('-') === -1){
                
                for(let nms of ncomma){
                    if(!isNaN(parseInt(nms))){
                        n.push(parseInt(nms))
                        hasNumbers =true
                    }else{
                        hasNumbers = false
                    }
                }

            }else if(nperiod.length === 2&& tableNumbers.indexOf(',') === -1 ){
               

                let from = parseInt(nperiod[0])
                let to = parseInt(nperiod[1])
                if(!isNaN(from) && !isNaN(to)){
                    
                    if(to-from <= 50){ // max table can be created 50
                        for(let i = from ;i<=to;i++){
                            n.push(i)
                        }
                         hasNumbers= true
                    }

                }

            }

           

        }
       

        if(hasNumbers && category && category.title.length>1){
            onAdd(n,category.title, extraFields)
            return
        }
        Notiflix.Report.Warning(
            "Warning",
            `please fill valid Table Numbers and valid category`,
            "Close"
          );
        
        
        
        
        
    }


    useDialogA11y(dialogRef, closeHandler, opened);

    return(
        <React.Fragment>
        {opened && <div ref={dialogRef} role="dialog" aria-modal="true" aria-label="Add Table">
            <Modal isOpen onClose={()=>{
                setTableNumbers(null)
                setCategory(null)
                closeHandler()
            }} size={'xl'}>
          <Modal.Content >
            <Modal.CloseButton accessibilityLabel="Close" />
            <Modal.Header>
              <HStack alignItems={'center'}>
                <Text fontSize={'lg'}>
                 Add Table
              </Text>
              
              </HStack>
            
            </Modal.Header>
            <Modal.Body>
            <HStack alignItems={'center'}>
            
              <Text fontSize={'md'}>
                 Table Location :
              </Text>
              <Autocomplete
                size={'small'}
                value={category}
                onChange={(event, newValue) => {
                    if (typeof newValue === 'string') {
                        setCategory({
                        title: newValue,
                    });
                    } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    setCategory({
                        title: newValue.inputValue,
                    });
                    } else {
                        setCategory(newValue);
                    }
                }}
                filterOptions={(options, params) => {
                    const filtered = filter(options, params);

                    const { inputValue } = params;
                    // Suggest the creation of a new value
                    const isExisting = options.some((option) => inputValue === option.title);
                    if (inputValue !== '' && !isExisting) {
                    filtered.push({
                        inputValue,
                        title: `Add "${inputValue}"`,
                    });
                    }

                    return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={categories.map(c=>{
                    return{
                        title:c
                    }
                })}
                getOptionLabel={(option) => {
                    // Value selected with enter, right from the input
                    if (typeof option === 'string') {
                    return option;
                    }
                    // Add "xxx" option created dynamically
                    if (option.inputValue) {
                    return option.inputValue;
                    }
                    // Regular option
                    return option.title;
                }}
                renderOption={(props, option) => <li {...props}>{option.title}</li>}
                sx={{ width: 300,margin:2 }}
                freeSolo

                renderInput={(params) => (
                    <TextField {...params} label="Enter Location or category" />
                )}

    />

              </HStack>
              <HStack alignItems={'center'}>
                <Text>
                Table Number/s :
                </Text>

                <TextField
                size="small"
                value={tableNumbers}
                onChange={(e)=>{
                    setTableNumbers(e.target.value)
                }}
                sx={{ width: 300,margin:2 }}
                  label={'Enter numbers seprated by (,) or (-)'}
                />
              </HStack>

              <HStack alignItems={'center'} mt={2}>
                <Text fontSize={'md'}>Table Type :</Text>
                <TextField
                  size="small"
                  select
                  value={tableType}
                  onChange={(e) => setTableType(e.target.value)}
                  sx={{ width: 200, margin: 2 }}
                  label="Table Type"
                >
                  <MenuItem value="standard">Standard</MenuItem>
                  <MenuItem value="booth">Booth</MenuItem>
                  <MenuItem value="bar-stool">Bar Stool</MenuItem>
                  <MenuItem value="high-top">High-Top</MenuItem>
                  <MenuItem value="high-table">High-Table</MenuItem>
                  <MenuItem value="counter">Counter</MenuItem>
                </TextField>
              </HStack>

              <HStack alignItems={'center'} mt={2}>
                <Text fontSize={'md'}>Seats :</Text>
                <TextField
                  size="small"
                  type="number"
                  value={seatCount}
                  onChange={(e) => setSeatCount(e.target.value)}
                  sx={{ width: 100, margin: 2 }}
                  label="Seat Count"
                  inputProps={{ min: 1, max: 20 }}
                />
              </HStack>

              <HStack alignItems={'center'} mt={2}>
                <Text fontSize={'md'}>Zone :</Text>
                <TextField
                  size="small"
                  select
                  value={zone}
                  onChange={(e) => setZone(e.target.value)}
                  sx={{ width: 150, margin: 2 }}
                  label="Zone"
                >
                  <MenuItem value="inside">Inside</MenuItem>
                  <MenuItem value="outside">Outside</MenuItem>
                </TextField>
              </HStack>

              <HStack alignItems={'center'} mt={2}>
                <Text fontSize={'md'}>Floor :</Text>
                <TextField
                  size="small"
                  select
                  value={floor}
                  onChange={(e) => setFloor(e.target.value)}
                  sx={{ width: 200, margin: 2 }}
                  label="Floor"
                >
                  <MenuItem value="ground">Ground Floor</MenuItem>
                  <MenuItem value="outside">Outside</MenuItem>
                  <MenuItem value="upstairs">Upstairs</MenuItem>
                  <MenuItem value="downstairs">Downstairs</MenuItem>
                </TextField>
              </HStack>

              <HStack alignItems={'center'} mt={2}>
                <FormControlLabel
                  control={<MuiCheckbox checked={wheelchairAccessible} onChange={(e) => setWheelchairAccessible(e.target.checked)} />}
                  label="Wheelchair Accessible"
                />
              </HStack>

              <HStack alignItems={'center'} mt={1}>
                <FormControlLabel
                  control={<MuiCheckbox checked={elevated} onChange={(e) => setElevated(e.target.checked)} />}
                  label="Raised Section (elevated platform)"
                />
              </HStack>

              <Button mt={3} onPress={()=>{onAddClicked()}}>
                Add
              </Button>
            
            </Modal.Body>
            </Modal.Content>
            </Modal>
        </div>}
        </React.Fragment>
    )
}

export default AddTableModal